import {Fragment} from "react";
import {Result, StatsDistribution} from "../types/types";
import styled from "styled-components";

type Props = {
	distribution: StatsDistribution
	activeGuesses?: number
}

export default function DistributionGraph ({distribution, activeGuesses}: Props) {
	const rows : any[] = []
	let totalWins = 0
	for (let numGuesses in distribution) {
		//@ts-ignore
		totalWins += distribution[numGuesses]
	}
	for (let numGuesses in distribution) {
		const numWins = distribution[numGuesses] as number
		let percent = 0
		if (totalWins) {
			percent = Math.round((numWins/totalWins) * 100)
		}

		rows.push({
			numGuesses,
			numWins: numWins,
			percent: percent
		})
	}

	return <Container>
		<h5>Guess Distribution</h5>
		{rows.length === 0 && <div style={{textAlign: 'center'}}>None yet.</div>}
		{rows.length > 0 && <BarsContainer>
			{rows.map((row, i) => {
				return <Fragment key={i}>
					<div className={'num-guesses ' + (row.numGuesses == 9 ? 'wrong' : '')}>{row.numGuesses}</div>
					<div className={'bar-container'}>
						<Bar style={{width: row.percent + '%'}} data-active={activeGuesses == row.numGuesses} $active={activeGuesses == row.numGuesses}>
							{row.numWins}
						</Bar>
					</div>
				</Fragment>
			})}
		</BarsContainer>}
	</Container>
}

const Container = styled.div`
	h5 {
		color: ${props => props.theme.colorLighterGray};
		text-align: center;
		margin-bottom: 0.5em;
	}
`

const BarsContainer = styled.div`
	display: grid;
	grid-template-columns: min-content 1fr;
	grid-template-gutter: 2px;
	background: ${props => props.theme.colorDarkish};
	padding: 0.25em 0;

	.num-guesses {
		padding: 0.25em 0.5em;
		display: flex;
		align-items: center;
		text-align: center;

		&.wrong {
			color: ${props => props.theme.colorWrong};
		}
	}

	.bar-container {
		display: flex;
		align-items: center;
		padding: 0.25em 0.5em 0.25em 0;
	}
`

const Bar = styled.div<{$active: boolean}>`
	background: ${props => props.$active ? props.theme.colorPrimary : props.theme.colorLighterGray};
	color: ${props => props.$active ? props.theme.colorPrimaryOpposite :props.theme.colorDark};
	height: 100%s;
	padding: 0.25em 0.5em;
	text-align: right;
`
